import { render, staticRenderFns } from "./chinaMap.vue?vue&type=template&id=6ac4158d&scoped=true"
import script from "./chinaMap.vue?vue&type=script&lang=js"
export * from "./chinaMap.vue?vue&type=script&lang=js"
import style0 from "./chinaMap.vue?vue&type=style&index=0&id=6ac4158d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac4158d",
  null
  
)

export default component.exports